// src/firebase.js
import { initializeApp } from 'firebase/app';
import {
  getDatabase,
  ref,
  push,
  get,
  child
} from 'firebase/database';

// ✅ Firebase Config (unchanged)
const firebaseConfig = {
  apiKey: "AIzaSyBzb9gJT_iyQIy5c0yY2rQJJ5PFZuV2lTk",
  authDomain: "hardware-project-f2463.firebaseapp.com",
  databaseURL: "https://hardware-project-f2463-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "hardware-project-f2463",
  storageBucket: "hardware-project-f2463.appspot.com",
  messagingSenderId: "402637444834",
  appId: "1:402637444834:web:ad38953174612908b470bb"
};

// ✅ Initialize Firebase App & DB
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// ✅ Export only Realtime Database functions
export { database, ref, push, get, child };